import { render, staticRenderFns } from "./updateKnowledgeBase.vue?vue&type=template&id=31e6dd4b"
import script from "./updateKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./updateKnowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./updateKnowledgeBase.vue?vue&type=style&index=0&id=31e6dd4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports